var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container-lg p-4" }, [
    _c(
      "div",
      {
        staticClass:
          "slide d-flex align-items-center justify-content-center flex-column flex-lg-row",
      },
      [
        _c(
          "div",
          { staticClass: "titles-width text-center text-lg-left mb-4 mb-lg-0" },
          [
            _c("h2", [_vm._v(_vm._s(_vm.title))]),
            _c("p", [_vm._v(_vm._s(_vm.description))]),
            _vm.button
              ? _c(
                  "a",
                  {
                    staticClass: "btn btn-primary mb-3 slide-button",
                    attrs: {
                      href: _vm.button.href,
                      target: _vm.button.target,
                      role: "button",
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.button.text[_vm.T.locale] || _vm.button.text["es"]
                        ) +
                        " "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _c(
          "div",
          { staticClass: "image-container d-flex justify-content-center" },
          [
            _c("img", {
              staticClass: "d-block img-fluid image-width",
              attrs: {
                src: _vm.imageSrc,
                alt: _vm.title,
                width: "480",
                height: "480",
              },
            }),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }